// src/modules/app-views/_apps/appmulti/receivables/pages/Document/decorators/response.js
// *******************************************************************************
// RESPONSE DECORATOR — backend already adds __customer, __statusView, and the
// flat fee fields (interest/fine/discount). Keep FE-side passthrough so the form
// store receives doc unchanged.
// *******************************************************************************
const decorateResponse = ctx => {
  const { doc } = ctx;
  if (!doc) return doc;
  return { ...doc };
};

export default decorateResponse;
